// extracted by mini-css-extract-plugin
module.exports = {"container":"item-container_container__1YL2e"};